import React from "react";
import { Upload } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
const UploadLocation = ({ name, setLocation, location, initialValues,height='90px' }) => {
  const token = localStorage.getItem("token");

  const { loading, imageUrl } = location;

  const handleChange = (info) => {
    if (info.file.status === "uploading") {
      setLocation({ loading: true });
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.

      setLocation({
        imageUrl: info.file.response.url,
        loading: false,
      });
    }
  };

  const uploadButton = (
    <div className="uploaderImage gx-w-100">
      {loading ? (
        <LoadingOutlined />
      ) : (
        <div>
          {" "}
          <span
            className="icon icon-image gx-d-block"
            style={{ fontSize: "33px", opacity: "0.3" }}
          ></span>
          <span>Upload Location Image</span>
        </div>
      )}
    </div>
  );

  const ImageProps = {
    action: `${process.env.REACT_APP_ROOT_URL}/uploadProfileImage`,
    method: "POST",
    headers: {
      Authorization: token,
    },
    body: { file: name },
    onChange: handleChange,
    multiple: false,
    listType: "picture-card",
    className: "avatar-uploader gx-w-100",
    showUploadList: false,
  };

  return (
    <div>
      <Upload name={name} {...ImageProps} className="uploaderImage gx-w-100">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="avatar"
            style={{
              width: "100%",
              height: height,
              borderRadius: "6px",
              objectFit: "cover",
            }}
          />
        ) : (
          uploadButton
        )}
      </Upload>
    </div>
  );
};

export default UploadLocation;
